/**
 * Safe RegExp Utilities (Client-side)
 * Prevents ReDoS (Regular Expression Denial of Service) attacks
 * 
 * This is a client-side version of server/utils/regex-utils.js
 * Both should be kept in sync for consistency
 */

/**
 * Escape special regex characters in a string
 * @param {string} str - The string to escape
 * @returns {string} - The escaped string safe for use in RegExp
 * @throws {Error} - If argument is not a string
 */
export function escapeRegex(str) {
  if (typeof str !== 'string') {
    throw new Error('Input must be a string');
  }
  
  // Limit input length to prevent ReDoS
  if (str.length > 1000) {
    throw new Error('Input string too long for regex (max 1000 characters)');
  }
  
  // Escape all special regex characters
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

